import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-detransc',
  templateUrl: './consulta-detransc.component.html',
  styleUrls: ['./consulta-detransc.component.scss']
})
export class ConsultaDetranscComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {}

}
